import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { get } from "utils/request";
import Loading from "components/atoms/Loading";
import { useRouter } from "components/hooks";
import { getUserIncentives } from "apis/user";
// import { getIncentivesForMagnet } from "apis/magnets";
import { useState } from "react";
import clsx from "clsx";
import IncentiveModal from "components/organisms/activations/IncentiveModal";
import MagnetPageMementoCard, { MagnetPageMementoCardDesktop } from "./MementoCard";
import { SPECIAL_RENDRING_BRAND_IDS, TOAST_CONFIG } from "../../constants";
import { MementoEmptyStates } from "./EmptyStates";

function MagnetIncentives({
  isCustomizedUIBrand = false,
  isMobile,
  pollsResponded = [],
  socialShareResponded = [],
}: {
  isCustomizedUIBrand?: boolean;
  isMobile?: boolean;
  pollsResponded?: string[];
  socialShareResponded?: string[];
}) {
  const [currentlyViewingIncentiveId, setCurrentlyViewingIncentiveId] = useState<string>("");

  const router = useRouter();

  const { magnetId } = router.query;

  const handleGetAllMagnetMenentosError = (errorMessage: string) => {
    toast.error(errorMessage, TOAST_CONFIG);
  };

  const {
    isLoading,
    data: allMagnetMementoData,
    error,
    isFetching,
  } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ["incentives", magnetId],
    queryFn: () =>
      get(`${getUserIncentives()}?magnet_id=${magnetId}`, {
        processError: handleGetAllMagnetMenentosError,
      }),
  });

  if (isLoading && isFetching) return <Loading />;

  if (error) return <p>Something went wrong</p>;

  const handleMementoClick = (mementoId: string) => {
    setCurrentlyViewingIncentiveId(mementoId);
  };

  return (
    <>
      {!!currentlyViewingIncentiveId && (
        <IncentiveModal
          incentiveData={allMagnetMementoData.filter((ele: any) => ele.id === currentlyViewingIncentiveId)[0]}
          pollsResponded={pollsResponded}
          socialShareResponded={socialShareResponded}
          isOpen={!!currentlyViewingIncentiveId}
          onClose={() => setCurrentlyViewingIncentiveId("")}
        />
      )}
      {isMobile ? (
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-4">
          {!allMagnetMementoData?.length ? (
            <div className="col-span-3">
              <MementoEmptyStates isDark={isCustomizedUIBrand} />
            </div>
          ) : (
            // TODO: Fix the logic here
            allMagnetMementoData.map((memento: any) => (
              <MagnetPageMementoCard
                key={`${memento.id}magnetPageMementoCard`}
                actionPending={memento.action_pending}
                name={memento.name}
                imageUrl={memento.thumbnail_url || (memento?.thumbnail_url as string)}
                mementoType={memento.incentive_rules.conditions.activation_key}
                isClickable
                handleOnClick={() => handleMementoClick(memento.id)}
                activationIconURL={memento.thumbnail_url}
                owns={memento.owns}
              />
            ))
          )}
        </div>
      ) : (
        <div
          className={clsx(
            "secondary-scrollbar grid-flow-cols grid overflow-y-auto px-4 pb-2 2xl:px-8",
            isCustomizedUIBrand ? "grid-cols-1 gap-7" : "grid-cols-2 gap-y-4 lg:grid-cols-3 lg:gap-y-7",
          )}
        >
          {!allMagnetMementoData?.length ? (
            <div className="col-span-3">
              <MementoEmptyStates isDark={isCustomizedUIBrand} />
            </div>
          ) : (
            // TODO: Fix the logic here
            allMagnetMementoData?.map((memento: any) => (
              <MagnetPageMementoCardDesktop
                textDark={SPECIAL_RENDRING_BRAND_IDS.includes(memento.brand_id)}
                key={`${memento.id}brandPublicProfileMementoCard`}
                actionPending={memento.action_pending}
                name={memento.name}
                imageUrl={memento.thumbnail_url}
                mementoType={memento.activation_key}
                isClickable
                handleOnClick={() => handleMementoClick(memento.id)}
                activationIconURL={memento.thumbnail_url}
                owns={memento.owns}
              />
            ))
          )}
        </div>
      )}
    </>
  );
}
export default MagnetIncentives;
